// extracted by mini-css-extract-plugin
module.exports = {"table-cheatsheet":"cheatsheet_table-cheatsheet__dm5xj","sticky":"cheatsheet_sticky__WVHzt","sidebar":"cheatsheet_sidebar__b9kFc","innerBtn":"cheatsheet_innerBtn__MX0hk"};